import PropTypes from 'prop-types'
import React from 'react'

const AttnLogo = ({ classes, theme, menuOpen }) => {
  const logoSrc = {
    default: 'https://assets.attn.com/logos/logo-navy.svg',
    dark: 'https://assets.attn.com/logos/logo-white.svg'
  }

  let logo
  if (menuOpen || theme === 'dark') {
    logo = logoSrc.dark
  } else {
    logo = logoSrc.default
  }

  return (
    <img
      src={logo}
      alt='attn'
      className={classes}
    />
  )
}

AttnLogo.propTypes = {
  classes: PropTypes.string,
  theme: PropTypes.string
}

export default AttnLogo



// WEBPACK FOOTER //
// ./src/components/attn-logo.js